<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <Sidebar></Sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="24" class="gutter-row">
            <h2>
              <a-breadcrumb>
                <a-breadcrumb-item>Premium Sites</a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.query.subscriptionStatus">
                  <template v-if="$route.query.subscriptionStatus === 'active'">
                    Active Subscription
                  </template>
                  <template v-else>
                    Subscription Expired
                  </template>
                </a-breadcrumb-item>
              </a-breadcrumb>
            </h2>
          </a-col>
        </a-row>
        <paid-sites></paid-sites>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import PaidSites from "@/components/Sites/PaidSites.vue";

export default {
  name: 'PaidSitesIndex',
  components: {
    Sidebar,
    PaidSites
  },
  data() {
    return {
      datacollection: null
    };
  },
  methods: {}
};
</script>
<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  margin: 16px;
  font-size: 1.3em;
  text-align: center;
  color: #fff;
}
</style>
